import { CustomButton, SvgWarning } from '@ui-kit'
import { PaySignErrorPopupConfig } from '../../types/common'

const PaySignErrorPopup: React.FC<PaySignErrorPopupConfig> = ({
  heading,
  message,
  initialState,
  setPaysignErrorPopup,
  ConfirmButtonText,
  list = [],
}) => {
  return (
    <>
      <div className="px-20 py-8 flex flex-col items-center mb-4 justify-center text-sm border-b">
        <div className="flex items-center gap-4">
          <div
            className={`bg-error-100 rounded-full h-[3.625rem] min-w-[3.625rem] flex items-center justify-center self-start`}
          >
            <SvgWarning />
          </div>
          {heading && (
            <span>
              <pre className="text-sm text-accent-700 font-primary font-bold">
                {heading}
              </pre>
            </span>
          )}
        </div>
        <div>
          {message && (
            <span>
              <pre className="text-sm mt-4 font-medium text-accent-700 font-primary">
                {message}
              </pre>
            </span>
          )}
        </div>
      </div>
      {list.length > 0 && (
        <div>
          <ul className="list-disc pl-6 mt-4">
            {list.map((message) => (
              <li
                key={`${message}`}
                className="text-sm font-medium text-accent-700 font-primary"
              >
                {message}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className={`flex gap-3 items-center justify-end w-full`}>
        <CustomButton
          dataQaId="custom-button-accept-confirm-dialog-paysign"
          onClick={() => setPaysignErrorPopup(initialState)}
          color="primary"
          isFilled={true}
          height="h-8"
          onKeyDown={(e) => {
            if (e?.key === 'Enter' || e?.key === ' ') {
              e?.preventDefault()
              e?.stopPropagation()
              setPaysignErrorPopup(initialState)
            }
          }}
        >
          {ConfirmButtonText}
        </CustomButton>
      </div>
    </>
  )
}

export default PaySignErrorPopup
